// Aura sends IsOptional 0 for items already priced into the fan sell price, so those are listed as
// included rather than as options. Manually added rows have isOptional null/true and stay options.
// Only included items can be hidden, so an optional motor from Aura still shows as an option.
export const groupLineItems = (lineItems) => lineItems.reduce((groups, item, index) => {
    const included = item.isOptional === false;

    if (included && item.attributes?.isHidden) return groups;

    groups[included ? 'included' : 'options'].push({ item, index });
    return groups;
}, { included: [], options: [] });
